import React from "react";
import dp from "../../Assets/sadakalo.png";
import { FaLongArrowAltRight } from "react-icons/fa";

const Banner = () => (
  <div>
      <div class="hero min-h-screen bg-base-500">
    <div class="hero-content flex-col lg:flex-row-reverse">
      <img src={dp} width={350} class="max-w-sm rounded-lg shadow-2xl" />
      <div>
        <h3 class="text-3xl font-bold text-accent">Hello,</h3>
        <h1 class="text-5xl font-bold py-5 text-white">
          I am <span className="text-primary">AL NEED ROY SUVRA</span>
        </h1>
        <h6 class="text-3xl font-bold py-5 text-secondary">
          Full Stack Web Developer
        </h6>
        <p class="py-6 text-base-300">
         I am a hard working full stack web developer. This is my personal portfolio. Here you can know about me and my prospectves.
        </p>
        <button class="btn text-xl btn-primary">
          Hire Me <FaLongArrowAltRight />{" "}
        </button>
      </div>
    </div>
  </div>
  </div>
);

export default Banner;
